<div class="wrap">
    <div class="intro">
      <div class="welcome">   
        <p id="headline"> ABOUT OUR CHURCH</p>
        <div class="line"></div>
        <p id="paragraph"> ቅዱስ ገብርኤል የኢትዮጵያ ኦርቶዶክስ ተዋሕዶ ገዳም የኢትዮጵያ ኦርቶዶክስ ተዋሕዶ ቤተ ክርስቲያን አካል ነው
            ቴክሳስ፣ ኦክላሆማ፣ ሉዊዚያና፣ አርካንሳስ እና ሃዋይ ሀገረ ስብከት እግዚአብሔርን እያገለገለ እና አገልግሎት ሲሰጥ ቆይቷል
            እና የኢትዮጵያ ኦርቶዶክስ ተዋሕዶ ቤተ ክርስቲያን ዶግማ፣ አስተምህሮ፣ ወግ፣ ታሪክና እምነት ከ2002 ዓ.ም ጀምሮ ለዳላስና ፎርት ወርዝ አካባቢ ማኅበረሰብ አስተምሮታል። እና አካል ጉዳተኞች በቅዱስ ውሃ ብቅ ማለት እና ቅባት
            የተባረከ ዘይቶች. በቅዱስ ገብርኤል ገዳም ሁሉም ሰው እንኳን ደህና መጣችሁ። 
        </p>
        <p id="paragraph"> ቅዱስ ገብርኤል የኢትዮጵያ ኦርቶዶክስ ተዋሕዶ ገዳም የኢትዮጵያ ኦርቶዶክስ ተዋሕዶ ቤተ ክርስቲያን አካል ነው
            ቴክሳስ፣ ኦክላሆማ፣ ሉዊዚያና፣ አርካንሳስ እና ሃዋይ ሀገረ ስብከት እግዚአብሔርን እያገለገለ እና አገልግሎት ሲሰጥ ቆይቷል
            እና የኢትዮጵያ ኦርቶዶክስ ተዋሕዶ ቤተ ክርስቲያን ዶግማ፣ አስተምህሮ፣ ወግ፣ ታሪክና እምነት ከ2002 ዓ.ም ጀምሮ ለዳላስና ፎርት ወርዝ አካባቢ ማኅበረሰብ አስተምሮታል። እና አካል ጉዳተኞች በቅዱስ ውሃ ብቅ ማለት እና ቅባት
            የተባረከ ዘይቶች. በቅዱስ ገብርኤል ገዳም ሁሉም ሰው እንኳን ደህና መጣችሁ። 
        </p>
        <button class="donate">BE A MEMBER</button>
      </div>
    <div class="image-intro">
        <div class="img-container">
          <img src="./assets/betechristian.PNG" />
          <p style="font-family:verdana; color:#650006">I was overjoyed when they said, “Let’s go up to the house of the Lord." - Psalm 122:1</p> 
        </div>
    </div>
  </div> 

<div class="clergy-container">
    <div>
        <h2> OUR CHURCH CLERGY</h2>
    </div>
    
    <div class="high-priest">
        <div class="papacy">
            <div class="papacy-image">
                <img src="./assets/Abune.jpg"/>
            </div>
            <p>ቴክሳስ እና አካባቢው ሀገረ ስብከት<br> ሊቀ ጳጳስ አባ ሳዌሮስ</p>
       </div> 
       <div class="Komos">
           <div class="komos-image">
               <img src="./assets/abahawaz.jpg"/>
           </div>
           <p>መልዓከ ፀሀይ ቆምስ አባ ሐዋዝ</p>
       </div> 
    </div>
      
    <div class="priest">
          <div class="priest-container">
                <div class="priest-image">
                    <img src="./assets/profilePlaceHolder.jpg"/>
                </div>
                <p>ቄሰ ገበዝ ጀንበሩ ታለማ</p>
          </div>
          <div class="priest-container">
                <div class="priest-image">
                    <img src="./assets/profilePlaceHolder.jpg"/>
                </div>
                <p>ቀሲስ ዶክተር ጌጤ አበጀ ዘውዴ</p>
          </div>
          <div class="priest-container">
                <div class="priest-image">
                    <img src="./assets/profilePlaceHolder.jpg"/>
                </div>
                <p>ሊቀ ጠበብት መሪጌታ ጥበቡ መስፍን</p>
          </div>
    </div>
    
    <div class="deacons">
        <div class="deacons-container">
            <div class="deacons-image">
                <img src="./assets/profilePlaceHolder.jpg"/>
            </div>
            <p>ሊቀ ዲያቆን ኤፍሬም</p>
        </div>
        <div class="deacons-container">
            <div class="deacons-image">
                <img src="./assets/profilePlaceHolder.jpg"/>
            </div>
            <p>ዲያቆን ማቴዎስ አበበ</p>
        </div>
        <div class="deacons-container">
            <div class="deacons-image">
                <img src="./assets/profilePlaceHolder.jpg"/>
            </div>
            <p>ዲያቆን በረከት ጌጤ አበጀ</p>
        </div>
        <div class="deacons-container">
            <div class="deacons-image">
                <img src="./assets/profilePlaceHolder.jpg"/>
            </div>
            <p>ዲያቆን ልዑል አዲስ ገብረ ሚካኤል</p>
        </div>
        <div class="deacons-container">
            <div class="deacons-image">
                <img src="./assets/profilePlaceHolder.jpg"/>
            </div>
            <p>ዲያቆን አናንያ ኤልያስ</p>
        </div>
    </div>

    <div>
        <div class="singers-container">
            <div class="header">
                <h3>Amde Haimanot Sunday School Youth Choir</h3>
            </div>
            <div class="singers-image">
                <img src="./assets/mezemran.jpg"/>
            </div>
        </div>
        <div class="singers-container">
            <div class="header">
                <h3>Saint Gabriel Children's Choir</h3>
            </div>
            <div class="singers-image align-left" style="margin: 10px 0px 15px 55px;">
                <img src="./assets/Kids_mezemran.png"/>
            </div>
        </div>
    </div>
             
        
</div>


     


 



